<template>
    <div>
  
      <p>
        <h2> 初始化之前会重置全部数据哦,注意注意,咳 但是你看到这里其实已经点了已经没有办法了  </h2>
<h2> 初始化设备状态,  显示创建结果 init_device  ";  </h2>
<h2> 12月25日  新设计 init device  </h2>
      </p>
    
  
    </div>
  </template>
  <script>



export default {
    data() {
      return  {   r:{
      }}
      },
created:function(){
  //注意回调函数的作用域!!!
  this.$http.get("/da/init_device").then( (response)=>  {
this.r = response.data

    console.log(response.data)
  })
},

mounted:function(){
  console.log("/da/init_device ==>   完毕")
}

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  